import { isEmpty, isNil } from 'ramda';

export const requiredValidator = (required: boolean) => (value: unknown) => {
  if (required && (isNil(value) || isEmpty(value))) {
    return true;
  }

  return null;
};
